import Noty from 'noty'

export default function noty(opts) {
    new Noty(Object.assign({
        theme: 'bootstrap-v3',
        timeout: 3000,
        type: 'info',
    }, opts)).show()
}
